<template>
  <div class="list">
    <div class="orderListT">
      <div class="orderListThead">
        <img src="static/images/left1.png"  alt class="orderListTheadReturn" @click="back" />
        <p>余额记录</p>
        <img src="static/images/query.png"  alt class="orderListTheadQuery"/>
      </div>
      <div class="orderListTC">
        <h2>总余额(元)</h2>
        <h3>{{balanceInfo.total}}</h3>
      </div>
      <!-- <div class="orderListTB">
        <p>充值总额：￥500.00</p>
        <p>支出总额：￥9000.00</p>
      </div> -->
    </div>
    <div class="orderListC">
      <div class="orderListCT">
        <h4>收支明细</h4>
        <p>
          <img src="static/images/all.png"  alt/>
          查看全部
        </p>
      </div>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <ul class="orderListCO">  
          <li v-for="(item, index) in records" :key="index" class="orderListCOa">
            <div class="orderListCOE">
              <h4>{{item.types}}</h4>
              <p>{{item.createTime}}</p>
            </div>
            <div class="orderListCOER">
              <h4 style="text-align: right;">{{item.amounts}}</h4>
              <p>余额{{item.amountEnds}}</p>
            </div>
          </li>
        </ul>
      </van-list>
    </div>

  </div>
</template>

<script>
import {amount} from "../api/api"
export default {
  name: 'balance',
  data () {
    return {
      balanceInfo: {},
      records: [],
      loading: false,
      finished: false,
      params: {
        current: 1,
        size: 10
      }
    }
  },
  mounted() {
    this.balanceList()
  },
  methods: {
    // 返回上一页
    back() {
      this.$router.go(-1)
    },
    // 加载更多
    onLoad() {
      this.params.current ++
      this.balanceList()
    },
    // 余额记录
    balanceList() {
      amount(this, this.params).then(res => {
        if(res.code == 200) {
          this.balanceInfo = res.data
          const list = res.data.page.records
          if(list == null || list.length === 0) {
            this.finished = true
            return
          }
          if (list.length < res.data.page.size) {
            this.finished = true
          }
          if (res.data.page.pages === 1) {
            this.records = list
          } else {
            this.records = this.records.concat(list)
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
 

</style>



// WEBPACK FOOTER //
// src/components/balance.vue